export default "__VITE_ASSET__Cd1z6TgE__"